/**
 * name 热点图谱
 * author zhang.yingyu
 * createTime 2019-04-02
 **/
"use strict";
angular.module("hotPointAtlasModule",[])
    .controller("hotPointAtlasCtrl",["$scope","$q","trsHttpService","modalDialog","$state","$filter",function($scope,$q,trsHttpService,modalDialog,$state,$filter){
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         */
        function initStatus() {
            $scope.status = {
                showDetailPanel: true,
                choiceRelationType: [
                    {name: "自动关联热点", value: 0},
                    {name: "手动关联热点（可多选）", value: 1},
                ],
                relativeTypeTips: {
                    keywords:[],
                    org:[],
                    name:[],
                },
                selectRelativeTypeTip: [],
                choiceRelationTypeData: "",
                title:$state.params.title,
                hotId:$state.params.id,
                relationInvalid:false,
                showRelationPointer:false,
                currentGroupIndex:0,
                relationGroupNum:5,
            };
            $scope.data={};
            $scope.data.optionData= {
                keywords: $state.params.keywords,
                org: $state.params.org,
                name: $state.params.name,
                title:$state.params.title,
                type:"commonRelate",
                relateData:[],
                changeWidth:$scope.status.showDetailPanel,
                source:"",
            };
            if(!$state.params.keywords){
                $scope.status.relationInvalid=true;
            }
            $scope.status.choiceRelationTypeData = $scope.status.choiceRelationType[0].value;
            for(var i in $scope.status.relativeTypeTips){
                $scope.status.relativeTypeTips[i]=getKewordsData($state.params[i],i);
            }
        };
        /**
         * [initData description]初始化数据
         */
        function initData() {
            if($scope.status.hotId){
                getHotDetail($scope.status.hotId);
            }else{
                $scope.status.showDetailPanel=false;
            }
        };
        /**
         * [startRelate description] 开始关联
         * @return {[type]} [description]
         */
        $scope.startRelate=function(){
            $scope.status.currentGroupIndex=0;
            $scope.status.showRelationPointer=true;
            if($scope.status.choiceRelationTypeData===0){
                getRelationData($state.params.keywords,$state.params.org,$state.params.name,$state.params.title);
            }else{
                handGetRelativeData();
            }
        };
        /**
         * [getHotPointTime description] 获取热点时间
         */
        $scope.getHotPointTime=function(time){
            if(!!time){
                return $filter('date')(new Date(time), 'MM-dd HH:mm:ss');
            }
        };
        /**
         * [getHotDetail description] 获取热点详情
         * @return {[type]} [description]
         */
        function getHotDetail(id){
            var defer=$q.defer();
            var params={
                'modelid':"detail",
                'serviceid': 'hotspotAssociation',
               'id':id,
            };
            $scope.loadingPromise=trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),params,"get").then(function(data){
                $scope.data.detailList=data;
                defer.resolve(data);
            });
            return defer.promise;
        };
        /**
         * [getRelationData description] 获取关联数据
         * @return {[type]} [description]
         */
        function getRelationData(keywords,org,name,title){
            var defer=$q.defer();
            var params={
                'modelid':"relation",
                'serviceid': 'hotspotAssociation',
                'keywords':keywords,
                'org':org,
                'name':name,
                'title':title,
            };
            $scope.loadingPromise=trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),params,"get").then(function(data){
                if(data.RELATION.PAGEITEMS){
                    $scope.data.optionData.keywords=keywords;
                    $scope.data.optionData.org=org;
                    $scope.data.optionData.name=name;
                    $scope.data.showKeywords=getSplitData(data.KEYWORDS);
                    $scope.data.showOrg=getSplitData(data.ORG);
                    $scope.data.showName=getSplitData(data.NAME);
                    $scope.data.totalRelationLen=data.RELATION.PAGEITEMS.length;
                    $scope.data.totalRelationDataLen=Math.ceil(data.RELATION.PAGEITEMS.length/$scope.status.relationGroupNum);
                    $scope.data.relationData=getCurrentGroupData(data.RELATION.PAGEITEMS,$scope.status.relationGroupNum);
                    $scope.data.optionData.relateData= $scope.data.relationData[$scope.status.currentGroupIndex];
                    $scope.data.optionData.source= "【源文】"+data.SOURCE;
                }else{
                    modalDialog.alertType('暂无匹配热点', '请更换匹配词重新尝试', 'info', false);
                    return;
                }
                defer.resolve(data);
            });
            return defer.promise;
        };
        /**
         * [getNextGroupData description] 获取下一分组数据
         */
        $scope.getNextGroupData=function(){
            $scope.status.currentGroupIndex++;
            if($scope.status.currentGroupIndex===$scope.data.totalRelationDataLen){
                $scope.status.currentGroupIndex=0;
            }
            $scope.data.remainder=$scope.status.relationGroupNum-$scope.data.relationData[$scope.status.currentGroupIndex].length;
            $scope.data.optionData.relateData= $scope.data.relationData[$scope.status.currentGroupIndex];
        };
        /**
         * [getCurrentGroupData description] 获得当前分组数据
         */
        function getCurrentGroupData(data,num){
            var resultArr=[];
            for(var i=0;i<data.length;i+=num){
                resultArr.push(data.slice(i,i+num));
            }
            return resultArr;
        };
        /**
         * [getRelationType description]关联类型切换
         */
        $scope.getRelationType = function (items) {
            if(items.value===0){
                $scope.status.selectRelativeTypeTip=[];
                for(var i in $scope.status.relativeTypeTips){
                    $scope.status.relativeTypeTips[i]=getKewordsData($state.params[i],i);
                }
            }
            $scope.status.choiceRelationTypeData = items.value;
        };
        /**
         * [initData description]手动获取热点
         */
        $scope.getRelativeTypeTips = function (items) {
            var index = $scope.status.selectRelativeTypeTip.indexOf(items);
            if (index < 0) {
                $scope.status.selectRelativeTypeTip.push(items);
            } else {
                $scope.status.selectRelativeTypeTip.splice(index, 1);
            }
        };
        function handGetRelativeData(){
            var keywords=[],org=[],name=[];
            $scope.status.selectRelativeTypeTip.forEach(function(item,index){
                if(item.type==="keywords"){
                    keywords.push(item.name);
                }else if(item.type==="org"){
                    org.push(item.name);
                }else{
                    name.push(item.name);
                }
            });
            function turnArrToStr(value){
                if(value.length>0){
                    value=value.join(";");
                }
                return value;
            };
            getRelationData(turnArrToStr(keywords),turnArrToStr(org),turnArrToStr(name),$state.params.title);
        };
        /**
         * [getSplitData description] 将字符串按;分割
         */
        function getSplitData(value){
            var arr=[];
            if(!!value){
                arr=value.split(";");
            }
            return arr;
        };
        /**
         * [getKewordsData description] 匹配关键词
         * @return {[type]} [description]
         */
        function getKewordsData(data,type){
            if(data){
                if(data) data=angular.copy(data).split(";");
                data=data.map(function(item,index){
                    var obj={
                        flag:false,
                        name:item,
                        type:type,
                    };
                    return obj;
                });
                return data;
            }
        }
        $scope.$on("getRelateChartData", function (event, data) {
            var tranDatas=data.tranDatas;
            if(tranDatas.taskId){
                getHotDetail(tranDatas.taskId);
            }
        });
    }]);